import _slicedToArray from "/Users/markus/Coding/GitHub/sailing/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/Users/markus/Coding/GitHub/sailing/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/Users/markus/Coding/GitHub/sailing/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/Users/markus/Coding/GitHub/sailing/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { forEach } from "./array";
import constant from "./constant";
import { RuntimeError } from "./errors";
import identity from "./identity";
import rethrow from "./rethrow";
import { variable_invalidation, variable_visibility } from "./runtime";
import Variable, { TYPE_DUPLICATE, TYPE_IMPLICIT, TYPE_NORMAL, no_observer } from "./variable";
export default function Module(runtime) {
  var builtins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  Object.defineProperties(this, {
    _runtime: {
      value: runtime
    },
    _scope: {
      value: new Map()
    },
    _builtins: {
      value: new Map([["invalidation", variable_invalidation], ["visibility", variable_visibility]].concat(_toConsumableArray(builtins)))
    },
    _source: {
      value: null,
      writable: true
    }
  });
}
Object.defineProperties(Module.prototype, {
  _copy: {
    value: module_copy,
    writable: true,
    configurable: true
  },
  _resolve: {
    value: module_resolve,
    writable: true,
    configurable: true
  },
  redefine: {
    value: module_redefine,
    writable: true,
    configurable: true
  },
  define: {
    value: module_define,
    writable: true,
    configurable: true
  },
  derive: {
    value: module_derive,
    writable: true,
    configurable: true
  },
  import: {
    value: module_import,
    writable: true,
    configurable: true
  },
  value: {
    value: module_value,
    writable: true,
    configurable: true
  },
  variable: {
    value: module_variable,
    writable: true,
    configurable: true
  },
  builtin: {
    value: module_builtin,
    writable: true,
    configurable: true
  }
});

function module_redefine(name) {
  var v = this._scope.get(name);

  if (!v) throw new RuntimeError(name + " is not defined");
  if (v._type === TYPE_DUPLICATE) throw new RuntimeError(name + " is defined more than once");
  return v.define.apply(v, arguments);
}

function module_define() {
  var v = new Variable(TYPE_NORMAL, this);
  return v.define.apply(v, arguments);
}

function module_import() {
  var v = new Variable(TYPE_NORMAL, this);
  return v.import.apply(v, arguments);
}

function module_variable(observer) {
  return new Variable(TYPE_NORMAL, this, observer);
}

function module_value(_x) {
  return _module_value.apply(this, arguments);
}

function _module_value() {
  _module_value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name) {
    var v;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            v = this._scope.get(name);

            if (v) {
              _context.next = 3;
              break;
            }

            throw new RuntimeError(name + " is not defined");

          case 3:
            if (v._observer === no_observer) {
              v._observer = true;

              this._runtime._dirty.add(v);
            }

            _context.next = 6;
            return this._runtime._compute();

          case 6:
            return _context.abrupt("return", v._promise);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _module_value.apply(this, arguments);
}

function module_derive(injects, injectModule) {
  var _this = this;

  var copy = new Module(this._runtime, this._builtins);
  copy._source = this;
  forEach.call(injects, function (inject) {
    if (typeof inject !== "object") inject = {
      name: inject + ""
    };
    if (inject.alias == null) inject.alias = inject.name;
    copy.import(inject.name, inject.alias, injectModule);
  });
  Promise.resolve().then(function () {
    var modules = new Set([_this]);

    var _iterator = _createForOfIteratorHelper(modules),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var module = _step.value;

        var _iterator2 = _createForOfIteratorHelper(module._scope.values()),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var variable = _step2.value;

            if (variable._definition === identity) {
              // import
              var _module = variable._inputs[0]._module;
              var source = _module._source || _module;

              if (source === _this) {
                // circular import-with!
                console.warn("circular module definition; ignoring"); // eslint-disable-line no-console

                return;
              }

              modules.add(source);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    _this._copy(copy, new Map());
  });
  return copy;
}

function module_copy(copy, map) {
  copy._source = this;
  map.set(this, copy);

  var _iterator3 = _createForOfIteratorHelper(this._scope),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _slicedToArray(_step3.value, 2),
          name = _step3$value[0],
          source = _step3$value[1];

      var target = copy._scope.get(name);

      if (target && target._type === TYPE_NORMAL) continue; // injection

      if (source._definition === identity) {
        // import
        var sourceInput = source._inputs[0],
            sourceModule = sourceInput._module;
        copy.import(sourceInput._name, name, map.get(sourceModule) || (sourceModule._source ? sourceModule._copy(new Module(copy._runtime, copy._builtins), map) // import-with
        : sourceModule));
      } else {
        copy.define(name, source._inputs.map(variable_name), source._definition);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return copy;
}

function module_resolve(name) {
  var variable = this._scope.get(name),
      value;

  if (!variable) {
    variable = new Variable(TYPE_IMPLICIT, this);

    if (this._builtins.has(name)) {
      variable.define(name, constant(this._builtins.get(name)));
    } else if (this._runtime._builtin._scope.has(name)) {
      variable.import(name, this._runtime._builtin);
    } else {
      try {
        value = this._runtime._global(name);
      } catch (error) {
        return variable.define(name, rethrow(error));
      }

      if (value === undefined) {
        this._scope.set(variable._name = name, variable);
      } else {
        variable.define(name, constant(value));
      }
    }
  }

  return variable;
}

function module_builtin(name, value) {
  this._builtins.set(name, value);
}

function variable_name(variable) {
  return variable._name;
}